import React from 'react';

const AssinaturaSection = ({
    permissaoUsuarioVerAssinatura,
    dadosAssinatura,
    imagemAssinatura,
    imagemAssinaturaPrint,
    data,
}) => (
<div
    className="assinatura-section scrollable"
    style={{
        padding: 'var(--spacing-size)',
        paddingTop: 0,
        textAlign: "center",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        marginTop:"auto",
        breakInside: 'avoid',
        pageBreakInside: 'avoid',
        overflowX: 'auto',
    }}
>
    <div
        style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
        }}
    >
        {(dadosAssinatura && permissaoUsuarioVerAssinatura) && (
            <>
                <img
                    className="assinatura-tela"
                    src={imagemAssinatura}
                    style={{
                        maxWidth: 260,
                        maxHeight: 80,
                        minWidth: 260,
                        minHeight: 5,
                        objectFit: "contain",
                    }}
                />

                <img
                    className="assinatura-print"
                    src={imagemAssinaturaPrint}
                    style={{
                        maxWidth: 260,
                        maxHeight: 80,
                        minWidth: 260,
                        minHeight: 5,
                        objectFit: "contain",
                    }}
                />

                <div
                  style={{
                    maxWidth: 260,
                    maxHeight: 5,
                    minWidth: 260,
                    minHeight: 5,
                  }}
                />
            </>
        )}
        {(!dadosAssinatura || !permissaoUsuarioVerAssinatura) && (
          <div
            style={{
              maxWidth: 260,
              maxHeight: 50,
              minWidth: 260,
              minHeight: 50,
            }}
          />
        )}

        <div
            className="assinatura-linha"
            style={{
                width: 260,
                marginTop: 'var(--half-spacing-size)',
                paddingTop: 'var(--half-spacing-size)',
                fontSize: 'var(--regular-text-size)',
                fontWeight: 700,
            }}
        >
            ASSINATURA
        </div>

        <div
            style={{
                marginTop: 'var(--half-spacing-size)',
                fontSize: 'var(--regular-text-size)',
                minHeight: 12,
            }}
        >
          {(data && permissaoUsuarioVerAssinatura)
              ? `${new Date(data).toLocaleDateString("pt-BR", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                })} às ${new Date(data).toLocaleTimeString("pt-BR", {
                    hour: "2-digit",
                    minute: "2-digit",
                })}`
              : "___ de ___________ de _______ às ___ : ___"}
        </div>

    </div>
</div>
);

export default AssinaturaSection;
